import axios from 'axios'

export function createHttp(config) {
  return axios.create(config)
}
